import React, { Component } from 'react'

import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import history from '../../../../history'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { convertNamesToOption, convertToOption } from '../../../../util'
import {
  Input,
  Popconfirm,
  Button,
  Form,
  Modal,
  DatePicker,
  AutoComplete,
  Icon,
  Spin,
  Radio,
  Select,
  message
} from 'antd'

import { actions as userActions } from '../../../../redux/modules/userActions'
import { actions as auditActions } from '../../../../redux/modules/auditActions'
import { actions as followUpActions } from '../../../../redux/modules/leadFunctions/leadFollowUpActions'

import * as authSelectors from '../../../../selectors/auth'
import * as revisionsSelectors from '../../../../selectors/revision'
// import * as leadFollowUpsSelectors from '../../../../selectors/lead/followups'

const FormItem = Form.Item
const RadioGroup = Radio.Group
const RadioButton = Radio.Button
const Option = Select.Option
const { TextArea } = Input

const propTypes = {
  action: PropTypes.string.isRequired,
  contentType: PropTypes.object,
  handleCancel: PropTypes.func.isRequired,
  leadId: PropTypes.any.isRequired,
  followUpIdParam: PropTypes.any,
  contentData: PropTypes.object
}

class AddEditFormModal extends Component {
  state = {
    assignToType: 'user'
  }

  handleChangeAssignedToType = e => {
    this.setState({
      assignToType: e.target.value
    })
  }

  handleCreate = () => {
    const form = this.props.form
    const { action, leadId, followUpIdParam } = this.props

    form.validateFields((err, values) => {
      if (err) {
        return
      }
      values.due_date = moment(values.due_date)
        .endOf('day')
        .format('YYYY-MM-DD hh:mm:ss')
      if (action === 'add') {
        this.props.createLeadFollowUp({
          leadId: leadId,
          content: values,
          userId: this.props.user.userId
        })
        message.success('Creating Followup.')
      } else {
        this.props.updateLeadFollowUp({
          leadId: leadId,
          followUpId: followUpIdParam,
          content: values,
          userId: this.props.user.userId
        })
        message.success('Changes saved.')
      }

      this.props.leadFollowUpsRefresh({
        leadId: leadId
      })

      form.resetFields()
      history.push(`/lead/${leadId}/followups/`)
    })
  }

  confirmDelete = event => {
    const { leadId, followUpIdParam } = this.props
    const form = this.props.form

    this.props.deleteLeadFollowUp({
      leadId: leadId,
      followUpId: followUpIdParam
    })

    form.resetFields()
    message.success('Record deleted.')
    history.push(`/lead/${leadId}/followups/`)
  }

  render() {
    const { contentData, revisions, loadingRevision, handleCancel, action } = this.props
    const { assignToType } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <Modal
        visible={true}
        title="Follow Ups"
        okText={action ? 'Save Changes' : 'Create'}
        onCancel={handleCancel}
        onOk={this.handleCreate}
        width={'80%'}
        maskClosable={false}
      >
        <Form layout="vertical">
          {contentData && (
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Status">
                  {getFieldDecorator('status', {
                    initialValue: contentData ? contentData.status : ''
                  })(
                    <RadioGroup>
                      <RadioButton value="Unopened">Unopened</RadioButton>
                      <RadioButton value="Opened">Opened</RadioButton>
                      <RadioButton value="Closed">Closed</RadioButton>
                      <RadioButton value="OVERDUE">OVERDUE</RadioButton>
                    </RadioGroup>
                  )}
                </FormItem>
              </div>
              {contentData && (
                <div className="col-md-3">
                  <FormItem label="Shortcut">
                    <Button icon="link" onClick={this.handleShortcut}>
                      {' '}
                      {/* {this.state.relatedId ? this.state.relatedId : this.state.shortcutId} */}
                    </Button>
                  </FormItem>
                </div>
              )}
              <div className="col-md-3">
                <FormItem label="Revision">
                  {getFieldDecorator('revision', {
                    initialValue:
                      revisions && revisions.length > 0 ? revisions[revisions.length - 1].id : null
                  })(
                    loadingRevision ? (
                      <Spin size="small" />
                    ) : (
                      <Select onChange={this.handleRevisionChange}>
                        {revisions &&
                          revisions.map(revision => (
                            <Option key={revision.id} value={revision.id}>
                              {revision.revision}
                            </Option>
                          ))}
                      </Select>
                    )
                  )}
                </FormItem>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-3">
              <FormItem label="Type">
                {contentData && contentData.type}
                {!contentData &&
                  getFieldDecorator('type', {
                    rules: [
                      {
                        required: true,
                        message: 'There must be a type'
                      }
                    ]
                  })(
                    <Select>
                      <Option key={1} value="General">
                        General
                      </Option>
                      <Option key={2} value="Callback">
                        Callback
                      </Option>
                    </Select>
                  )}
              </FormItem>
            </div>
            <div className="col-3">
              <FormItem label="Due Date">
                {getFieldDecorator('due_date', {
                  rules: [
                    {
                      required: true,
                      message: 'You must choose a due date'
                    }
                  ],
                  initialValue: contentData ? moment(contentData.due_date) : null
                })(<DatePicker format="MM/DD/YYYY" placeholder="Select Time" />)}
              </FormItem>
            </div>
            <div className="col-3">
              <FormItem label="Assigned To Type">
                {getFieldDecorator('assigned_to_type', {
                  initialValue: assignToType
                })(
                  <RadioGroup onChange={this.handleChangeAssignedToType}>
                    <RadioButton value="user">User</RadioButton>
                    <RadioButton value="role">Role</RadioButton>
                  </RadioGroup>
                )}
              </FormItem>
            </div>
            <div className="col-3">
              {assignToType === 'user' && (
                <FormItem label="Assign To User">
                  {getFieldDecorator('assigned_to_id', {
                    rules: [
                      {
                        required: assignToType === 'user' ? false : true,
                        message: 'You must assign this to someone'
                      }
                    ],
                    initialValue:
                      contentData && contentData.assigned_to_id
                        ? contentData.assigned_to_id.toString()
                        : ''
                  })(
                    <AutoComplete
                      dataSource={convertNamesToOption(
                        this.props.userActions &&
                          this.props.userActions.users &&
                          this.props.userActions.users.data
                      )}
                      filterOption={(inputValue, option) =>
                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                    >
                      <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                    </AutoComplete>
                  )}
                </FormItem>
              )}
              {assignToType === 'role' && (
                <FormItem label="Assign To Role">
                  {getFieldDecorator('assigned_to_role_id', {
                    rules: [
                      {
                        required: assignToType === 'role' ? false : true,
                        message: 'You must assign this to someone'
                      }
                    ],
                    initialValue:
                      contentData && contentData.assigned_to_role_id
                        ? contentData.assigned_to_role_id.toString()
                        : ''
                  })(
                    <AutoComplete
                      dataSource={convertToOption(
                        this.props.userActions &&
                          this.props.userActions.roles &&
                          this.props.userActions.roles.data
                      )}
                      filterOption={(inputValue, option) =>
                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                    >
                      <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                    </AutoComplete>
                  )}
                </FormItem>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  initialValue: contentData ? contentData.description : ''
                })(<TextArea placeholder="Type in your note..." rows={4} />)}
              </FormItem>
            </div>
          </div>

          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={this.confirmDelete}
            onCancel={this.cancelDelete}
            okText="Yes"
            cancelText="No"
          >
            {contentData && <Button type="danger" icon="delete" />}
          </Popconfirm>
        </Form>
      </Modal>
    )
  }
}

const mapStateToProps = (state, props) => ({
  leadFollowUpActions: state.leadFollowUpActions,
  userActions: state.userActions,
  revisions: revisionsSelectors.getRevisionsFromAudit(state, props),
  loadingRevision: revisionsSelectors.getRevisionsLoadingFromAudit(state, props),
  user: authSelectors.getUser(state, props)
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, followUpActions, userActions, auditActions), dispatch)
})

AddEditFormModal.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddEditFormModal))
)



// WEBPACK FOOTER //
// ./src/pages/lead/components/followups/AddEditFormModal.component.js